import React from "react";
import PaymentMethodStep from "~/pages/[brand]/return/methodSelector/PaymentMethodStep.js";

export default function ComplaintStepPaymentMethod({ appProps, complaintStepperProps }) {
    const { onBack, onModalClose, onPaymentMethodSave } = complaintStepperProps;
    return <PaymentMethodStep appProps={appProps} onBack={onBack} onModalClose={onModalClose} onPaymentMethodSave={onPaymentMethodSave} />;
}
